import {
    GridMenuButton,
    GridMenuItem,
} from '@/global/components/DataGrid/components/CustomGridToolBar/MenuComponents'
import { NoContextQuickFilter } from '@/global/components/DataGrid/components/QuickFilter'
import useDefaultFilterModel from '@/global/components/DataGrid/hooks/useDefaultFilterModel'
import { insensitive } from '@acme/common'
import { CsvMapper } from '@acme/core'
import { Divider } from '@mui/material'
import { Button } from 'global/components/Button'
import { SelectEmpresa } from 'global/components/Selects'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import {
    ArrowDownToLine,
    ArrowUpDownIcon,
    ArrowUpToLineIcon,
    PlusIcon,
} from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { CentroCusto, centroCusto } from 'service/api'
import { useStore } from 'store'
import ArvoreCentroCusto from 'templates/Cadastro/CentroCusto/Arvore'

class CentroCustoMapper extends CsvMapper<Partial<CentroCusto>> {}

export default function CentroCustoPage() {
    const empresaId = useStore(state => state.companyId)
    const { data: fetchedData } = centroCusto.useFetch({
        queryParams: { empresaId },
        enabled: !!empresaId,
    })
    const [quickFilter, setQuickFilter] = useDefaultFilterModel()
    const data = fetchedData
        ?.sort((a, b) => a.codigo.localeCompare(b.codigo))
        ?.filter(centro => {
            if (!quickFilter.quickFilterValue) return true

            const searchTerm = insensitive(quickFilter.quickFilterValue)
            return (
                insensitive(centro.codigo).includes(searchTerm) ||
                insensitive(centro.nomeCentroCusto).includes(searchTerm)
            )
        })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Cadastros', 'Centro de custos']}>
                    <SelectEmpresa hideWhenSingle />
                </ContentGuide.Header>
                <ArvoreCentroCusto fetchedData={data}>
                    <div className="flex flex-row items-center justify-between w-full p-2">
                        <GridMenuButton
                            label="Integração"
                            startIcon={<ArrowUpDownIcon />}
                        >
                            <GridMenuItem
                                label="Exportar"
                                startIcon={
                                    <ArrowUpToLineIcon className="mr-2" />
                                }
                                onClick={() => {
                                    new CentroCustoMapper(
                                        (data ?? []).map(centro => ({
                                            id: centro.id,
                                            codigo: centro.codigo,
                                            nomeCentroCusto:
                                                centro.nomeCentroCusto,
                                            predecessorId: centro.predecessorId,
                                        })),
                                    ).downloadCsv('exportacao-centro-custo')
                                }}
                            />
                            {hasPermission(['create', 'CentrosDeCusto']) && (
                                <GridMenuItem
                                    label="Importar"
                                    startIcon={
                                        <ArrowDownToLine className="mr-2" />
                                    }
                                    href="importar"
                                />
                            )}
                        </GridMenuButton>
                        <div className="flex flex-row items-center gap-2">
                            <NoContextQuickFilter
                                quickFilterValue={
                                    quickFilter.quickFilterValue ?? ''
                                }
                                onFilterModelChangePro={setQuickFilter}
                            />
                            {hasPermission(['create', 'CentrosDeCusto']) && (
                                <Button
                                    href="adicionar"
                                    startIcon={<PlusIcon />}
                                >
                                    Adicionar
                                </Button>
                            )}
                        </div>
                    </div>
                    <Divider
                        sx={{
                            mb: 1,
                            width: '100%',
                        }}
                    />
                </ArvoreCentroCusto>
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useCentroCustoOutletContext() {
    return useOutletContext<{
        data?: CentroCusto[]
    }>()
}
